import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/fb-marketplace-offers';

export default function Example() {
  return (
    <>
      <Head>
        <title>Supercharge your businesses with Facebook Marketplace offers</title>
        <meta
          name='description'
          content='Explore the many ways to do offers with Facebook Commerce Manager and how each one can help you bring in more sales.'
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/fb-marketplace-offers' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/fb-marketplace-offers' />
        <meta property='og:title' content='Supercharge your businesses with Facebook Marketplace offers' />
        <meta
          property='og:description'
          content='Explore the many ways to do offers with Facebook Commerce Manager and how each one can help you bring in more sales.'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=3' />
        <meta property='article:published_time' content='2022-06-14T00:00:00-00:00' />
        <meta property='article:modified_time' content='2022-06-14T00:00:00-00:00' />
        <meta property='article:tag' content='Facebook Marketplace' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
